import { createApp } from "vue"
import App from "./App.vue"
import store from "./store"

import "./styles/_global.scss" /* TODO: Revisit.  Is this the most efficient way 
to load global styles i.e. ones that need to target html, body tags? */

createApp(App).use(store).mount("#app")
